<template>
    <div/>
</template>

<script>

export default {
  data () {
    return {
      changeDataTimes: 0,
      selectedModel: {}, // 当前选中项数据模型
      curZoom: 1, // 当前缩放比率
      minZoom: 0.5, // 最小缩放比率
      maxZoom: 2 // 最大缩放比率
    }
  },
  mounted () {
    // 生成 G6 Editor 编辑器
    const width = window.innerWidth - 200
    const height = window.innerHeight - 38
    const editor = new G6Editor()
    // const minimap = new G6Editor.Minimap({
    //   container: 'minimap',
    //   height: 120,
    //   width: 200
    // })
    // const toolbar = new G6Editor.Toolbar({
    //   container: 'toolbar'
    // })
    const contextmenu = new G6Editor.Contextmenu({
      container: 'contextmenu'
    })
    const itempannel = new G6Editor.Itempannel({
      container: 'itempannel'
    })
    // const detailpannel = new G6Editor.Detailpannel({
    //   container: 'detailpannel'
    // })
    const page = new G6Editor.Flow({
      shortcut: {
        zoomIn: true,
        zoomOut: true
      },
      graph: {
        container: 'page',
        width,
        height
      },
      align: {
        grid: true
      }
    })
    this.registerCommands()
    this.handleCallbacks(page, editor)
    // editor.add(minimap)
    // editor.add(toolbar)
    editor.add(contextmenu)
    editor.add(itempannel)
    // editor.add(detailpannel)
    editor.add(page)
    this.page = page
    this.editor = editor
  },
  methods: {
    changeZoom (zoom) {
      const page = this.page
      page.zoom(zoom)
    },
    toggleGrid (checked) {
      const page = this.page
      if (checked) {
        page.showGrid()
      } else {
        page.hideGrid()
      }
    },
    updateGraph (key, value) {
      const editor = this.editor
      const page = this.page
      editor.executeCommand(() => {
        const selectedItems = page.getSelected()
        selectedItems.forEach(item => {
          const updateModel = {}
          updateModel[key] = value
          page.update(item, updateModel)
        })
      })
    },
    updateGraphByPropertyModel (propertyModel) {
      if (!propertyModel || typeof propertyModel !== 'object' || Object.keys(propertyModel).length === 0) {
        return
      }
      const editor = this.editor
      const page = this.page
      editor.executeCommand(() => {
        const selectedItems = page.getSelected()
        selectedItems.forEach(item => {
          page.update(item, propertyModel)
        })
      })
    },
    changeEdge (type) {
      this.page.changeAddEdgeModel({
        shape: type
      })
    },
    reRender () {
      const editor = this.editor
      editor.executeCommand(() => {
        const page = this.page
        const edges = page.getEdges()
        edges.forEach(item => {
          page.update(item, {color: '#828282'})
        })
      })
    },
    registerCommands () {
      const self = this
      const Command = G6Editor.Command
      Command.registerCommand('delete', {
        queue: !1,
        execute (editor) {
          self.$emit('deleteItems', editor.getCurrentPage())
        }
      })
      Command.registerCommand('undo', {
        shortcutCodes () {
          return []
        }
      })
      Command.registerCommand('redo', {
        shortcutCodes () {
          return []
        }
      })
    },
    handleCallbacks (page, editor) {
      page.on('afteritemselected', ev => {
        this.selectedModel = ev.item.getModel()
        this.$emit('selectItem', { item: ev.item, nodes: this.page.getNodes(), edges: this.page.getEdges() })
      })
      page.on('afterchange', ev => {
        console.info('afterchange', ev)
        if (ev.action === 'changeData') {
          this.changeDataTimes++
          if (this.changeDataTimes === 1) {
            return
          }
        }
        this.$emit('changeItems', editor, ev,
          {nodes: this.page.getNodes().map(s => s.getModel()), edges: this.page.getEdges().map(s => s.getModel())})
      })
      page.on('afterzoom', ev => {
        this.curZoom = ev.updateMatrix[0]
      })
      const graph = page.getGraph()
      graph.on('click', ev => {
        this.$emit('clickCanvas', ev.item)
      })
    }
  }
}
</script>
<style lang="scss">
*{
  font-size: 12px !important;
}
*, *::before, *::after {
  box-sizing: border-box;
}
input{
  font-size: 12px;
}
#editor canvas {
  display: block;
}
#editor{
  position: relative;
  width: 100%;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/g6/editor.vue